import React from "react";
import styled from "styled-components";

import LineSeedKrRg from "../../../../atoms/text/lineSeedKr/lineSeedKrRg";

const LSRgBody02 = (props) => {
  return <LSRgBody02Wrapper {...props} />;
};

export default LSRgBody02;

const LSRgBody02Wrapper = styled(LineSeedKrRg)`
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: -0.3px;

  color: #222222;
`;
